<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-ums__member}">
      <el-table v-loading="dataListLoading" :data="dataList" border
                @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="appNo" label="申请编码" header-align="center" align="center"></el-table-column>
        <el-table-column label="账户类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.balanceType===1">现金</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="金额" header-align="center" align="center"></el-table-column>
        <el-table-column label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.status===1">待执行</el-tag>
            <el-tag v-else-if="scope.row.status===2">已完成</el-tag>
            <el-tag type="info" v-else-if="scope.row.status===3">已取消</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="publishDate" label="发放日期" header-align="center" align="center"></el-table-column>
        <el-table-column label="操作" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status===2" type="text" size="small" @click="showShareDeviceMoney(scope.row.id)">查看会员分红</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <sharemoney-device ref="sharemoneyDeviceRef"></sharemoney-device>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import SharemoneyDevice from "./sharemoney-device";
export default {
  name: "sharemoney",
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/cp/sharemoney/page',
        getDataListIsPage: true,
      }
    }
  },
  created() {
    const that = this;
  },
  methods: {
    showShareDeviceMoney(id){
      const that=this;
      that.$refs.sharemoneyDeviceRef.init(id);
    }
  },
  components:{
    SharemoneyDevice,
  }
}
</script>

<style scoped>

</style>